import React, { FC, useEffect } from "react";
import MobilePhlebotomyStepper from "@app/pages/private/sampleDraw/create/mobilePhlebotomyStepper";
import {
  DrawRequestContext,
  KitContext,
  OrderRenewalContext,
} from "@app/provider";
import { ScheduleBloodDrawScreens } from "../scheduleBloodDraw";
import "./scheduleBloodDrawStepper.scss";
import { TestType } from "@app/provider/testData/types";
import { DrawRequestFlow } from "@app/provider/drawRequest";

interface ScheduleBloodDrawStepperProps {
  token: string;
  setBloodDrawScreen: React.Dispatch<
    React.SetStateAction<ScheduleBloodDrawScreens>
  >;
  flow?: DrawRequestFlow;
}

const ScheduleBloodDrawStepper: FC<ScheduleBloodDrawStepperProps> = ({
  token,
  setBloodDrawScreen,
  flow,
}) => {
  const { verifiedSampleDrawData } = React.useContext(DrawRequestContext);
  const { getRenewalInfo } = React.useContext(OrderRenewalContext);
  const { skipLabStep, skipKitShipping } = React.useContext(KitContext);

  const handleOnBackPreferenceStep = () =>
    setBloodDrawScreen(ScheduleBloodDrawScreens.PERSONAL_INFO_SCREEN);

  const handleOnBackKitShippingStep = () =>
    setBloodDrawScreen(
      skipLabStep && skipKitShipping
        ? ScheduleBloodDrawScreens.PERSONAL_INFO_SCREEN
        : ScheduleBloodDrawScreens.KIT_DETAILS_SCREEN
    );

  const handleCreateDrawRequestError = () =>
    setBloodDrawScreen(
      ScheduleBloodDrawScreens.CREATE_BLOOD_DRAW_FAILED_SCREEN
    );

  const testType = verifiedSampleDrawData?.sampleInfo.sample?.testType;
  const orderUidPublic =
    verifiedSampleDrawData?.sampleInfo.sample?.orderUidPublic;

  useEffect(() => {
    if (testType === TestType.SIGNATERA && orderUidPublic) {
      getRenewalInfo({ orderUidPublic, token });
    }
  }, [token]);

  return (
    <div className="guest-schedule-blood-draw">
      <div className="guest-schedule-blood-draw__content">
        <MobilePhlebotomyStepper
          onBackPreferenceStep={handleOnBackPreferenceStep}
          onBackKitShippingStep={
            flow === DrawRequestFlow.PUBLIC_MP
              ? undefined
              : handleOnBackKitShippingStep
          }
          handleCreateDrawRequestError={handleCreateDrawRequestError}
          testType={testType}
          orderUidPublic={orderUidPublic}
          testUid={verifiedSampleDrawData?.sampleInfo.sample?.testUid}
          profileAddresses={
            verifiedSampleDrawData?.profileInfo.profile?.addresses
          }
          token={token}
          isPublicRequest={flow === DrawRequestFlow.PUBLIC_MP}
        />
      </div>
    </div>
  );
};

export default ScheduleBloodDrawStepper;
